<div class="columns is-mobile" [class.has-pointer-cursor]="segment.canSelect">
  <div
    class="column is-one-fifth is-ppl-column pl-2"
    [class.hover]="segment?.isHovered || segment?.isChecked"
    [class.is-rescheduled]="
      !!segment?.recommendationFlights?.length || (isAirline && segment.isAffected)
    "
  >
    <!-- Segment Header: Ida/Vuelta - Tramo -->
    <div class="p-0 route">
      <div class="icon-segment-type-container">
        <span *ngIf="!!segment?.recommendationFlights?.length || (isAirline && segment.isAffected)">
          <em class="mdi mdi-alarm-check mdi-18px"></em>
        </span>

        <span *ngIf="!segment?.recommendationFlights?.length">
          <em
            *ngIf="segment.type === segmentType.Departure"
            class="mdi mdi-airplane mdi-18px mdi-rotate-90"
          ></em>
          <em
            *ngIf="segment.type === segmentType.Return"
            class="mdi mdi-airplane mdi-18px mdi-rotate-270"
          ></em>
          <em
            *ngIf="segment.type === segmentType.Route"
            class="mdi mdi-airplane mdi-18px mdi-rotate-45"
          ></em> </span
        >&nbsp;
        <span class="route-title" *ngIf="segment.type !== segmentType.Route">
          {{ 'itinerary-info.segments-info.' + segment.type | translate }}
        </span>
        <span class="route-title" *ngIf="segment.type === segmentType.Route">
          {{ 'itinerary-info.segments-info.segment' | translate }}
          {{ index + 1 }}</span
        >
      </div>
    </div>

    <div class="p-0 date">
      <span class="departure-date-container" attr.data-title="{{ segment.departureDate }}">
        {{ segment.departureDate | date | localizedDate : 'EEE d MMM y' }}
      </span>
    </div>
  </div>

  <div class="column is-3 pl-3em pr-0">
    <span class="is-uppercase weight-medium is-size-5">
      {{ segment.departureLocation.code }}
    </span>
    <span class="is-size-7 is-block is-lowercase is-capitalized">
      {{ segment.departureLocation.name }}
    </span>
  </div>

  <div class="column is-2 has-text-centered is-size-7 mt-auto">
    <p *ngIf="!showBaggage">
      {{ 'itinerary-info.flight.flight' | lowercase | translate }}
      {{ segment.flights[0]?.number }}
    </p>
    <p *ngIf="!showBaggage" [class.has-text-danger]="!segment.flights[0]?.classOfService">
      {{ 'itinerary-info.flight.class' | translate }}:
      {{ segment.flights[0]?.classOfService }}
    </p>
  </div>

  <div class="column is-3 pl-3em pr-0">
    <span class="is-uppercase weight-medium is-size-5">
      {{ segment.arrivalLocation.code }}
    </span>
    <span class="is-size-7 is-block is-lowercase is-capitalized">
      {{ segment.arrivalLocation.name }}
    </span>
  </div>

  <!-- Seat availible -->
  <div class="column is-3 pl-2em pr-0">
    <div *ngIf="!fareBasisSegment?.hasFarebasisCodes">
      <span class="is-size-12 has-text-grey">{{
        'itinerary-info.segments-info.no-farebasis-info' | translate
      }}</span>
    </div>

    <div *ngIf="fareBasisSegment?.hasFarebasisCodes">
      <div *ngFor="let farebasis of fareBasisSegment.farebasisCodes; let i = index">
        <span class="is-size-7 weight-medium">FB {{ i + 1 }}: </span>
        <span class="is-size-7">{{ farebasis }}<br /></span>
      </div>
    </div>

    <span
      class="is-size-7 is-block is-lowercase is-capitalized text-color"
      *ngIf="showSeatsAvailability && isAirline && isInvoluntary"
    >
      {{ seatsNotAvailable ? '' : seatsAvailable ? '' : ('seats.status.no-available' | translate) }}
    </span>

    <span
      class="is-size-7 is-block is-lowercase is-capitalized text-color"
      *ngIf="isAirline && checkAvailableClassesIsVoid()"
    >
      {{ 'seats.status.no-available' | translate }}
    </span>
  </div>
  <!-- End Seat availible -->

  <div class="column is-3" *ngIf="showBaggage && !isAirline">
    <em class="mdi mdi-briefcase mdi-24px"></em>
    <em *ngIf="baggageAllowance >= 2" class="mdi mdi-briefcase mdi-18px"></em>

    <span class="is-size-7 is-block">
      {{ 'itinerary-info.baggageAllowance' | translate }}
      {{ baggageAllowance }} pc
    </span>
  </div>
</div>

<div class="columns is-mobile">
  <div class="column is-one-fifth pl-3">
    <ng-container *ngFor="let iconUrl of filteredIconsUrl">
      <img class="pr-1" [src]="iconUrl" alt="" />
    </ng-container>
  </div>
  <div class="column is-3 pl-3em pr-0">
    {{ segment?.departureDate | date : 'HH:mm' }}
  </div>

  <div class="column is-2 has-text-centered">
    <span class="is-size-6 is-block" *ngIf="segment.flights.length === 1">
      {{ 'itinerary-info.segments-info.direct' | translate }}
    </span>
    <span class="is-size-6 is-block" *ngIf="segment.flights.length === 2">
      {{ segment.flights.length - 1 }}
      {{ 'itinerary-info.segments-info.scale' | translate }}
    </span>
    <span class="is-size-6 is-block" *ngIf="segment.flights.length > 2">
      {{ segment.flights.length - 1 }}
      {{ 'itinerary-info.segments-info.scales' | translate }}
    </span>
    <div class="stop-counter">
      <div class="stop-counter-line"></div>
      <div class="stops-wrapper">
        <span *ngFor="let item of segment.flights.slice(1)"></span>
      </div>
    </div>
  </div>

  <div class="column is-3 pl-3em pr-0">
    {{ segment?.arrivalDate | date : 'HH:mm' }}
    <span *ngIf="segment.daysDifference > 0" class="is-size-7 has-text-danger">
      +{{ segment?.daysDifference }}
    </span>
  </div>
  <div class="column is-2">
    <span class="is-pulled-left">
      {{ segment?.timeOfFlight | TimeOfFlight }}
    </span>
  </div>
</div>
